<template>
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 20.9785C15.5228 20.9785 20 16.5014 20 10.9785C20 5.45567 15.5228 0.978516 10 0.978516C4.47715 0.978516 0 5.45567 0 10.9785C0 16.5014 4.47715 20.9785 10 20.9785Z"
            fill="#D80027"
        />
        <path
            d="M5.47266 7.06445L6.33594 9.7207H9.12891L6.87109 11.3652L7.73438 14.0215L5.47266 12.3809L3.21094 14.0215L4.07812 11.3652L1.81641 9.7207H4.60938L5.47266 7.06445Z"
            fill="#FFDA44"
        />
        <path
            d="M11.8555 16.4668L11.1953 15.6543L10.2188 16.0332L10.7852 15.1543L10.125 14.3379L11.1367 14.6074L11.707 13.7285L11.7617 14.7754L12.7773 15.0449L11.7969 15.4199L11.8555 16.4668Z"
            fill="#FFDA44"
        />
        <path
            d="M13.168 14.084L13.4805 13.084L12.625 12.4785L13.6719 12.4629L13.9805 11.4629L14.3203 12.4551L15.3672 12.4434L14.5273 13.0684L14.8633 14.0605L14.0078 13.4551L13.168 14.084Z"
            fill="#FFDA44"
        />
        <path
            d="M14.9375 8.31836L14.4766 9.25977L15.2266 9.99023L14.1914 9.8418L13.7305 10.7793L13.5508 9.74805L12.5117 9.59961L13.4414 9.11133L13.2617 8.07617L14.0117 8.80664L14.9375 8.31836Z"
            fill="#FFDA44"
        />
        <path
            d="M11.8828 5.4668L11.8047 6.50977L12.7773 6.9043L11.7578 7.1543L11.6836 8.20117L11.1328 7.31055L10.1133 7.56055L10.7891 6.75977L10.2344 5.87305L11.207 6.26758L11.8828 5.4668Z"
            fill="#FFDA44"
        />
    </svg>
</template>